import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import FormContainer from '../Components/FormContainer/FormContainer';
import * as shippingAction from '../Actions/shippingAction';
import * as shippingConstants from '../Constants/shippingConstants';
import ErrorMessage from '../Components/Message/errorMessage';
import {
  TextField,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  makeStyles,
} from '@material-ui/core/';
import { Link, Redirect } from 'react-router-dom';
import confirmationImg from '../Assests/confirmation.png';
import { confirmAlert } from 'react-confirm-alert';
import * as routes from '../Constants/routes';
import 'react-confirm-alert/src/react-confirm-alert.css';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  prgressColor: {
    color: '#000000',
  },
}));

const EditShipping = ({ match }) => {
  const shippingId = match.params.shippingtId;
  const shippingData = useSelector((state) => state.Shipping);
  const { loading, shipping, error, success } = shippingData;

  const updateShippingDetails = useSelector((state) => state.updateShippingDetails);
  const { loading: EditShippingLoading, error: EditShippingError, success: EditShippingSuccess } = updateShippingDetails;

  const [area, setArea] = useState('');
  // const [brand, setBrand] = useState('');
  const [shippingPrice, setShippingPrice] = useState(0);
  const [Success, setSuccess] = useState(false);

  const classes = useStyles();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(shippingAction.shipping(shippingId));

    // eslint-disable-next-line
  }, [dispatch, shippingId]);

  useEffect(() => {
    if (success) {
      setArea(shipping.area);
      setShippingPrice(shipping.shippingPrice);
    }

    // eslint-disable-next-line
  }, [dispatch, success]);
  const submitHandler = (e) => {
    e.preventDefault();
    const UpdateData = {
      area,
      shippingPrice,
    };
    dispatch(shippingAction.EditShipping(shippingId, UpdateData));
  };

  const ConfirmedAlert = () => {
    if (EditShippingSuccess) {
      return confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-ui-alert">
              <div className="success-img">
                <img src={confirmationImg} alt="confirmationImg" />
              </div>
              <h3 className="font-weight-bold text">Shipping Details updated successfully</h3>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={() => {
                  onClose();
                  dispatch({ type: shippingConstants.EDIT_SHIPPING_RESET });
                  setSuccess(true);
                }}
              >
                OK
              </Button>
            </div>
          );
        },
      });
    }
  };
  return (
    <>
      {Success && <Redirect to={routes.SHIPPING} />}
      {EditShippingError && (
        <ErrorMessage
          header="Something went wrong"
          message={EditShippingError}
          reset={shippingConstants.EDIT_SHIPPING_RESET}
        />
      )}
      <Link to={routes.SHIPPING} className="btn btn-light my-3">
        Go Back
      </Link>
      {loading ? (
        <h4>Loading...</h4>
      ) : error ? (
        <ErrorMessage header="Something went wrong" message={error} />
      ) : (
        <>
          <FormContainer>
            <h1>Edit Shipping Details</h1>
            <Form onSubmit={submitHandler}>
              

              <TextField
                variant="outlined"
                type="number"
                margin="normal"
                required
                fullWidth
                id="shippingPrice"
                label="Price"
                name="shippingPrice"
                autoComplete="price"
                autoFocus
                value={shippingPrice}
                onChange={(e) => setShippingPrice(Number(e.target.value))}
              />
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">Area</InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={(e) => setArea(e.target.value)}
                  label="Area"
                  value={area}
                >
        
                  <MenuItem value="Kawangware">Kawangware</MenuItem>
                  <MenuItem value="Congo">Congo</MenuItem>
                  <MenuItem value="Amboseli">Amboseli</MenuItem>
                  <MenuItem value="Lavington">Lavington</MenuItem>
                  <MenuItem value="Yaya">Yaya</MenuItem>
                  <MenuItem value="Hurlingham">Hurlingham</MenuItem>
                  <MenuItem value="Kitengela">Kitengela</MenuItem>
                </Select>
              </FormControl>

              <Button type="submit" variant="contained" color="primary" fullWidth disabled={EditShippingLoading}>
                {EditShippingLoading ? (
                  <CircularProgress color="inherit" className={classes.prgressColor} />
                ) : (
                  <>Update</>
                )}
              </Button>
            </Form>
          </FormContainer>
          {ConfirmedAlert()}
        </>
      )}
    </>
  );
};

export default EditShipping;
